import React from 'react'

const SkeletonPage = () => {
  return (
    <div className='skeleton_wrapper'>
      로딩중...
    </div>
  )
}

export default SkeletonPage
